module.exports = __webpack_public_path__ + "img/tent.e85f39df.svg";